/**
 * @see https://wiki.umu.work/pages/viewpage.action?pageId=21889570
 * @file  用微信的media_id换取资源URL
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    app_id: string;
    media_id: string;
    ext: string;
}

export interface IOutput {
    status: string;
    file_url: string;
}

export const getWxworkMediaUrl = (input: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.GET_MEDIA_URL, input);
};
